/**
 * Card
 */
import { Component, registerComponent } from 'js/component.js';

const componentName = 'stock-ticker';

class StockTicker extends Component {

    elements = {
        container: this.element.querySelector(`.${componentName}__container`),
        price: this.element.querySelector(`.${componentName}__price`),
        change: this.element.querySelector(`.${componentName}__change`),
        timestamp: this.element.querySelector(`.${componentName}__timestamp`),
        stock: this.element.querySelector(`.${componentName}__stock`)
    };

    onStockRequestSuccess(data) {
        // Write the current stock price.
        this.elements.price.innerHTML = `$${data.GetFullStockQuoteListResult[0].TradePrice.toFixed(2)}`;

        // Write the day's stock price change.
        const change = data.GetFullStockQuoteListResult[0].Change;
        const percChange = data.GetFullStockQuoteListResult[0].PercChange;
        const percChangeDirection = percChange >= 0 ? 'stock-ticker__arrow-up' : 'stock-ticker__arrow-down';
        this.elements.change.classList.add(percChangeDirection);

        this.elements.change.innerHTML = `${change.toString()} (${percChange.toString()}%)`;

        // Write the date of the stock price.
        const monthLanguageLabels = document.querySelector('.stock-ticker__month-labels');
        const monthLabels = [];
        for (let i = 0; i < 12; i += 1) {
            monthLabels.push(monthLanguageLabels.children[i].textContent);
        }

        const dt = new Date(data.GetFullStockQuoteListResult[0].TradeDate);
        const month = monthLabels[dt.getMonth()];
        const time = dt.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }).replace(/\s+/g, '').toLowerCase();
        const retrievedDate = `${time} ET • ${month} ${dt.getDate()}, ${dt.getFullYear()}`;
        this.elements.timestamp.innerHTML = this.elements.timestamp.innerHTML.replace('{0}', retrievedDate);
    }

    onStockRequestError() {
        this.elements.price.remove();
        this.elements.change.remove();
        this.elements.stock.remove();
        this.elements.timestamp.innerHTML = 'The stock quote is temporarily unavailable.';
    }

    async requestStockData() {
        const apiUrl = 'https://rockwell2023tf.q4web.com/feed/StockQuote.svc/GetFullStockQuoteList';
        const params = new URLSearchParams({
            apiKey: '5525CF53046D4AA2999217C08DC4358A',
            exchange: 'XNYS',
            symbol: this.elements.stock.dataset.ticker,
            pageSize: '1'
        });

        try {
            const response = await fetch(`${apiUrl}?${params}`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json,text/javascript,*/*;q=0.01'
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            this.onStockRequestSuccess(data);

        } catch (error) {
            console.error('Stock data request failed:', error);
            this.onStockRequestError();
        }
    }

    /**
     * Initialize Component
     */
    init() {
        if (this.elements.stock) {
            this.requestStockData();
        }
    }
}

registerComponent(`.${componentName}`, StockTicker);
